module.exports = __webpack_public_path__ + "img/bs.605b854e.svg";